<template>
  <div style="padding: 20px">

    <div class="tip">
      <p>在审核退货单时，实现不同退货单使用不同规则进行审核。若不设置分组，则视为统一处理。</p>
    </div>

    <!--按钮-->
    <div>
      <el-button class="mybtn-blue2" style="width: 100px" @click="showAddDialog()">新增</el-button>
    </div>

    <!--标题-->
    <div class="config-title">退货单分组</div>

    <!--表格-->
    <el-table :data="main$data" v-loading="main$loading" size="medium">
      <el-table-column type="index" label="序号" width="50" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="name" label="分组名称" width="180" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="app" label="用途" width="220" align="center" header-align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.app == '1'">审核</span>
                <span v-else-if="scope.row.app == '2'">仓库分配</span>
                <span v-else-if="scope.row.app == '3'">全部</span>
            </template>
        </el-table-column>
      <el-table-column prop="description" label="说明" width="260" align="center" header-align="center"> </el-table-column>
      <el-table-column prop="states" label="状态" width="100" align="center" header-align="center">
        <template slot-scope="scope">
            <span v-if="scope.row.states == '0'">停用</span>
            <span v-else-if="scope.row.states == '1'" style="color: #29CF87">启用</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" header-align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="table_update(scope.row)">修改</el-button>
          <el-button type="text" @click="table_delete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--dialog 新增、编辑-->
    <el-dialog :title="editDialogType=='add'?'新增退单分组':'编辑退单分组'"
               :visible.sync="editDialogVisible"
               class="mydialog mydialog_add_order_group"
               :append-to-body="true">
      <el-form :label-position="'right'" label-width="90px" class="myform">
        <input type="hidden" v-model="editData.id">
        <!--/-->
        <el-form-item label="分组名称：">
          <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.name"></el-input>
        </el-form-item>
        <!--/-->
        <el-form-item label="用途：">
          <el-radio-group v-model="editData.app">
            <el-radio label="1">审核</el-radio>
            <el-radio label="2">仓库分配</el-radio>
            <el-radio label="3">全部</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--/-->
        <el-form-item label="权重：">
          <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.weight"></el-input>
          <div class="dg-desc">填写数字越大，代表权重越高，优先级越高</div>
        </el-form-item>
        <!--/-->
        <el-form-item label="描述：">
          <el-input size="small" type="textarea" placeholder="请填写对退货的简要描述" v-model="editData.description"></el-input>
        </el-form-item>
        <!--/-->
        <el-form-item label="状态：">
          <el-radio-group v-model="editData.states">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="mybtn-blue2" @click="saveDialogData">保存</el-button>
        <el-button @click="editDialogVisible=false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 表格
            main$loading: false,
            main$data: [],
            // 新增、编辑对话框
            editDialogVisible:false,
            editDialogType:'',
            editData:{ }
        }
    },
    methods: {
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/rule/orderreturngroup/getList'), {

            }).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$data = [];
                }
                else {
                    self.main$data = res.data.data;
                }
            });
        },
        table_update: function (row) {
            let self = this;

            self.xEui.myloading('加载中...')
            self.xFetch.post(self.xApi('/robot/rule/orderreturngroup/getDetails'), {
                id:row.id
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                let obj = res.data.data;
                let editData = self.getDefaultEditData();

                editData.id = obj.id;
                editData.name = obj.name;
                editData.app = obj.app + '';
                editData.weight = obj.weight;
                editData.description = obj.description;
                editData.states = obj.states + '';

                // show dialog
                self.editDialogVisible = true;
                self.editDialogType = 'update';
                self.editData = editData;
            });
        },
        table_delete: function (row) {
            let self = this;
            self.xEui.confirm('','确认要删除该条记录吗？',function(){
                self.xEui.myloading('删除中...')
                self.xFetch.post(self.xApi('/robot/rule/orderreturngroup/delete'), {
                    id:row.id
                },{xPostType:'form'}).then(function (res) {
                    self.xEui.loading_close();

                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    else{
                        self.xEui.msg_success('删除成功')
                        self.fetchData();
                    }
                });
            })
        },
        getDefaultEditData: function(){
            let self = this;
            let editData = {
                states:'1'
            };
            return editData;
        },
        showAddDialog: function(){
            this.editDialogVisible = true;
            this.editDialogType = 'add';
            this.editData = this.getDefaultEditData();
        },
        saveDialogData: function(){
            let self = this;
            let postData = {
                'id':self.editData.id,
                'name':self.editData.name,
                'app':self.editData.app,
                'weight':self.editData.weight,
                'description':self.editData.description,
                'states':self.editData.states
            }

            if(!postData.name){
                self.xEui.msg_error('请输入名称')
                return;
            }

            if(!postData.app){
                self.xEui.msg_error('请选择用途')
                return;
            }

            // save
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi(
                    postData.id ? '/robot/rule/orderreturngroup/update' : '/robot/rule/orderreturngroup/add'
            ), postData).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                else {
                    self.xEui.msg_success('保存成功')
                    self.editDialogVisible = false;
                    self.fetchData();
                }
            });
        }
    },
    created: function () {
        let self = this;

        // 表格数据
        self.fetchData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-input, .el-select, .el-date-editor.el-input{
    width: 220px;
  }
  .el-textarea{
    width: 370px;
  }
  /*config-title*/
  .config-title{ font-size: 13px;color: #333;font-weight: 700;padding: 30px 0; }
  /*mydialog_add_order_group*/
  .mydialog_add_order_group{ }
  .mydialog_add_order_group .dg-input{ width: 220px }
  .mydialog_add_order_group .dg-desc{ font-size: 13px;color: #909399;line-height: 30px }
  p{
    margin: 0;
  }
</style>
<style>
  /*mydialog_add_order_group*/
  .mydialog_add_order_group .el-dialog__body{ padding: 20px;padding-bottom: 0 }
  .mydialog_add_order_group .el-form-item{ margin-bottom: 10px }
</style>


// WEBPACK FOOTER //
// src/views/config/strategy/return-group.vue